import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {InfoMessageService} from '../../services/infomessage/infomessage.service';
import {DoctorService} from '../../services/doctor/doctor.service';
import {PracticeService} from '../../services/practice/practice.service';
import {PracticeModel} from '../../models/practice/practice.model';
import {iResponse, iResponseList} from '../../models/response/response.model';
import {CdkAccordion, CdkAccordionItem} from '@angular/cdk/accordion';
import {NgClass} from '@angular/common';
import {DoctorModel} from '../../models/doctor/doctor.model';
import {DoctorCreateComponent} from '../doctor-create/doctor-create.component';
import {DoctorEditComponent} from '../doctor-edit/doctor-edit.component';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';
import {
    AdministrationDoctorSettingsComponent
} from '../administration-doctor-settings/administration-doctor-settings.component';

@Component({
    selector: 'app-doctor-administration',
    imports: [
        CdkAccordion,
        CdkAccordionItem,
        NgClass,
        DoctorCreateComponent,
        DoctorEditComponent,
        AdministrationDoctorSettingsComponent
    ],
    templateUrl: './doctor-administration.component.html',
    styleUrl: './doctor-administration.component.sass'
})
export class DoctorAdministrationComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    practiceList: PracticeModel[] = [];

    doctorCreateInPractice: string = '';
    doctorEditInPractice: string = '';
    doctorSettingsOpen: string = '';

    constructor(
        private infoMessageService: InfoMessageService,
        private practiceService: PracticeService,
        private doctorService: DoctorService,
        private dialog: MatDialog
    ) {
    }

    ngOnInit(): void {
        this.getPractices();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    openDoctorCreate(practiceId: string): void {
        if (this.doctorCreateInPractice === practiceId) {
            this.doctorCreateInPractice = '';
        } else {
            this.doctorCreateInPractice = practiceId;
        }
    }

    handleDoctorCreated(event: any, practice: PracticeModel): void {
        this.getDoctorsForPractice(practice);
    }

    openDoctorEdit(doctorId: string): void {
        if (this.doctorEditInPractice === doctorId) {
            this.doctorEditInPractice = '';
        } else {
            this.doctorEditInPractice = doctorId;
        }
    }

    openDoctorSettings(doctorId: string): void {
        if (this.doctorSettingsOpen === doctorId) {
            this.doctorSettingsOpen = '';
        } else {
            this.doctorSettingsOpen = doctorId;
        }
    }

    openConfirmModal(id: string): void {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            closeOnNavigation: true,
            disableClose: true,
            data: {text: 'Soll der Arzt wirklich geloescht werden ?', header: 'Löschen', delete: true}
        })

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.deleteDoctor(id);
            }
        })
    }


    handleDoctorUpdated(event: any, practice: PracticeModel): void {
        this.getDoctorsForPractice(practice);
    }

    private getPractices(): void {
        this.practiceService.getPracticeList()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponseList<PracticeModel>) => {
                    this.practiceList = response.data;
                    this.parseDoctorsForPractices();
                },
                error: (error) => {
                    console.error(error)
                }
            })
    }

    private parseDoctorsForPractices() {
        this.practiceList.forEach(practice => {
            this.getDoctorsForPractice(practice);
        })
    }

    private getDoctorsForPractice(practice: PracticeModel): void {
        this.doctorService.getDoctorsForPractice(practice.id)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponseList<DoctorModel>) => {
                    practice.doctorList = response.data;
                },
                error: (error) => {
                }
            })
    }

    private deleteDoctor(id: string): void {
        this.doctorService.deleteDoctor(id)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponse<boolean>) => {
                    this.getPractices();
                    this.infoMessageService.createMessage('Arzt erfolgreich geloescht', 'success');
                },
                error: (error) => {
                }
            })
    }

}
